import {
  packagesApi,
  PackageLodgingShopResponseEnum,
} from "@b2bportal/packages-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import type { TPackagesByRateId } from "../slice";

export const fetchHotelsShop = createAsyncThunk<
  TPackagesByRateId,
  { opaqueShopRequest: string; opaquePackageToken: string }
>(
  "packages/fetchHotelsShop",
  async ({ opaqueShopRequest, opaquePackageToken }, thunkAPI) => {
    try {
      const res = await packagesApi(axios).apiV0PackagesLodgingShopPost({
        opaquePackageToken: { value: opaquePackageToken },
        opaqueShopRequest,
      });

      switch (res.data.PackageLodgingShopResponse) {
        case PackageLodgingShopResponseEnum.Available:
          return { packagesByRateId: res.data.packagesByRateId };
        case PackageLodgingShopResponseEnum.Failure:
          return thunkAPI.rejectWithValue({
            error: PackageLodgingShopResponseEnum.Failure,
          });
        case PackageLodgingShopResponseEnum.Unavailable:
          return thunkAPI.rejectWithValue({
            error: PackageLodgingShopResponseEnum.Unavailable,
          });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: String(error) });
    }
  }
);
